// extracted by mini-css-extract-plugin
export default {"wrapper":"image-placeholder_wrapper__bxG3p","emptyBox":"image-placeholder_emptyBox__vAmm9"};